export { default } from './Menu';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Menu/index.js
// module id = 342
// module chunks = 0